import { Formik } from 'formik'
import { Button, InputField, Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { EditProgramIprops } from '../type'
import { programSchema } from '../../schema'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { editprogram } from '../../slice/trainingslice'
import { editProgram } from '../../api'

const EditProgram = ({ show, onClose, data }: EditProgramIprops) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Edit Program"
            body={
                <Formik
                    initialValues={{
                        title: data.title,
                    }}
                    validationSchema={programSchema}
                    onSubmit={async (values) => {
                        const payload = {
                            title: values.title,
                            description: values.title,
                            programId: data.id,
                        }

                        try {
                            // Call the asynchronous function and wait for its result
                            await editProgram(payload)
                            dispatch(
                                SHOW_NOTIFICATION({
                                    type: 'success',
                                    message: 'Program update successfully',
                                })
                            )

                            dispatch(editprogram({ payload: payload }))

                            // You can also use the data received from the API if needed
                        } catch (err) {
                            // Handle any errors here
                            console.error('Error fetching holidays:', err)
                        }
                        onClose(false)
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <InputField
                                type="text"
                                name="title"
                                lable="Program name"
                                value={values.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.title}
                                touched={touched.title}
                            />
                            <div className="footer-block">
                                <Button type="submit">SAVE</Button>
                                <Button
                                    type="button"
                                    variant="outline-success"
                                    onClick={() => onClose(false)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    )}
                </Formik>
            }
        />
    )
}
export default EditProgram
